<template>
  <div>
      <!-- {{icard_data}} -->
      <div class="cardbody">
          <div v-if="icard_data != ''" style="width: 18rem;">
              <div>
                  <v-row dense>
                      <!-- <v-col></v-col> -->
                      <!-- <v-col cols="12" sm="2" md="2"></v-col> -->
                      <v-col cols="12" sm="12" md="12">
                          <img class="logo" style="margin-top: -6px;" :src="icard_data[0].logo" height="90" width="100%" alt="logo" />
                      </v-col>
                      <!-- <v-col cols="12" sm="2" md="2"></v-col> -->
                  </v-row>

                  <div>
                      <center style="margin-top: -6px; font-size: 0.7em;">
                          <span class="schlname" v-html="icard_data[0].school_name"> </span><br />
                          <span class="schladdr">{{ icard_data[0].school_address }}</span><br />
                      </center>
                  </div>

                  <div class="empimg">
                      <v-img style="background-color: white;" height="220px" :src="icard_data[0].watermark">
                          <center>
                              <img :src="icard_data[0].profile_photo_path" class="box1" style="width: 38%; height: 132px; margin-top: 10px;" />
                          </center>

                          <center style="font-size: 0.7em;">
                              <div class="text-center">
                                  <h2 style="color: white;">{{ icard_data[0].name }}</h2>
                              </div>
                              <div class="text-center">
                                  <h2 style="color: white;">{{ icard_data[0].designation }}</h2>
                                  <h2 style="color: white;">
                                      ZPRN:&nbsp;{{ icard_data[0].emp_code }}
                                  </h2>
                              </div>
                          </center>
                      </v-img>
                      <center>
                          <svg id="barcode2"></svg>
                      </center>
                  </div>
              </div>
          </div>
      </div>
      <br />
      <div style="margin-top: -12px;" class="cardbody pagebreak">
          <div v-if="icard_data != ''" style="width: 18rem;">
              <div>
                  <v-img :src="icard_data[0].watermark_back"></v-img>
                  <v-row justify="center">
                      <v-col cols="12" sm="12" md="12">
                          <!-- <div class="ml-1" style="font-size: 0.83em;height:60px">
                          <strong>Address : </strong>{{icard_data[0].emp_address}}
                      </div> -->
                          <div class="ml-3" style="font-size: 0.8em;">
                              <strong>Address : </strong>{{ icard_data[0].emp_address }}
                              <br />
                              <strong> Phone : </strong> {{ icard_data[0].emp_contact }}<br />
                              <strong> Emergency Contact: </strong>
                              {{ icard_data[0].emp_emergency_contact }}<br />
                              <strong>D.O.B.: </strong> {{ icard_data[0].emp_dob }}<br />
                              <strong>Blood Group: </strong>{{ icard_data[0].emp_blood_group }}<br />
                              <!-- <strong>Email :- </strong>{{icard_data[0].emp_email}}<br /> -->
                              <strong>Joining Date: </strong>{{ icard_data[0].emp_doj }}<br />
                          </div>
                      </v-col>
                  </v-row>
                  <strong class="ml-3" style="font-size: 1em;">Rules:-</strong>
                  <!-- <hr /> -->
                  <v-row dense v-for="(i, index) in icard_data[0].instruction" :key="index">
                      <!-- <h5>* {{ i.topic }}</h5> -->
                      <ul class="inst">
                          <li style="padding-left: 0.3em;">{{ i.topic }}</li>
                      </ul>
                  </v-row>
                  <div>
                      <v-row>
                          <v-col cols="12" sm="3" md="3"> </v-col>
                          <v-col cols="12" sm="9" md="9" align="right">
                              <img :src="icard_data[0].sign" style="width: 45%; height: 45px; margin-top: -6px; margin-right: 25px;" alt="logo" /><br />
                              <strong style="margin-right: 35px;">{{ authority }}</strong>
                          </v-col>
                      </v-row>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
  import axios from "axios";
  import VueBarcode from "vue-barcode";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard

  export default {
      components: {
          barcode: VueBarcode,
      },
      data: () => ({
          comp_load: false,
          inst_list: null,
          radios: null,
          inst_data: null,
          icard_data: [],
          barcodeValue: "",
          authority: "Principal",
          authority_sign: null,
      }),
      updated: function () {
          //console.log("Inside updated");
          this.$nextTick().then(() => {
              if (this.icard_data != "") {
                  this.barcoded();
              }
          });
      },
      mounted() {
          this.inst_data = JSON.parse(localStorage.getItem("inst_data"));
          this.authority = localStorage.getItem("authority");
          this.icardGenerate();
      },
      methods: {
          print() {
              this.$store.state.drawer = false;
              let that = this;
              window.onafterprint = function () {
                  that.$store.state.drawer = true;
              };
              setTimeout(function () {
                  window.print();
              }, 100);
          },
          icardGenerate() {
              const data = {
                  inst_data: this.inst_data,
              };
              axios
                  .post("/Icard/icardGenerate", data)
                  .then((res) => {
                      this.icard_data = res.data.icard_data;
                      this.authority_sign = res.data.icard_data[0].director_sign;
                      if (this.authority == "Director") {
                          this.authority = "Founder Director";
                          this.icard_data[0].sign = this.authority_sign;
                      }
                      // this.barcoded();
                  })

                  .catch((error) => {
                      console.log("Error", error);
                      alert("Somthing went wrong!!!");
                  })
                  .finally(() => {
                      this.comp_load = false;
                  });
          },
          barcoded() {
              // barcode
              console.log("in barcode function");
              var x = this;
              setTimeout(function () {
                  JsBarcode("#barcode2", x.icard_data[0].emp_code, {
                      // textAlign: "left",
                      // height: "46",
                      // textPosition: "top",
                      font: "cursive",
                      fontOptions: "bold",
                      // fontSize: 15,
                      // textMargin: 3,
                      // text: x.icard_data[0].emp_code,
                      displayValue: false,
                  });
              }, 500);

              /// barcode end
          },
      },
  };
</script>

<style scoped>
  .box1 {
  }
  .boxnew {
      background-color: white;
      width: 300.52755905896px;
      height: 204.01889764021797px;
      padding-left: 3px !important;
      padding-right: 2px !important;
      background-repeat: no-repeat !important;
  }
  .cardbody {
      width: 300px;
      display: inline-block;
      border-radius: 5px;
      padding: 5px;
      height: 480px;
      padding-top: 15px;
  }
  .schlname {
      color: #023a9c;
      font-size: large;
      font-weight: bold;
  }

  .schladdr {
      font-weight: bold;
  }

  .schlphone {
      font-weight: bold;
  }

  .signature {
      width: 38%;
      height: 60px;
      margin-bottom: 13px;
      margin-right: -70px;
  }
  * {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
  }

  #barcode2 {
      /* height: 188px; */
      margin-top: 5px;
      height: 60px;

      /* width: 100%; */
      width: 50%;
  }
  @media print {
      .pagebreak {
          page-break-before: always !important;
      }

      #noprint {
          display: none !important;
      }
      @page {
          margin: -0.2645833mm;
          /* size: 54.102mm 86.614mm; */
          size: 53mm 86.614mm;
      }
      .logo {
          /* width: 80%; */
          height: 85%;
      }
  }
  ul.inst {
      list-style-type: "*";
      font-weight: 500;
      font-size: 14px;
      text-align: left;
  }
</style>
